import { useGetAccountInfo } from 'services/account-info/useAccountInfo'
import { handleBackButton, hasWebViewHeader } from 'utils'
import { useAppInfo } from 'hooks/useAppInfo'
import { Header } from 'components/Header'

import { Text, Icon, Divider } from '@interco/inter-toranja'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { TextSize } from '@interco/inter-toranja/dist/components/Atoms/Text/types'

import { Card } from '../components/Card'
import { Notice } from '../components/Notice'
import { Understand } from '../components/Understand'
import { AccountInfoSkeleton } from '../AccountInfoSkeleton'
import { AccountInfoError } from '../AccountInfoError'

const title = {
  'pt-BR': 'Dados bancários',
  'en-US': 'Account Information',
  'es-ES': 'Información bancaria',
}

export const AccountInfoUS = () => {
  const { data, isFetching, isError, refetch } = useGetAccountInfo()

  const { appVersion, language, isDarkMode } = useAppInfo()
  const hasHeader = hasWebViewHeader(appVersion)

  const renderAccountInfo = () => {
    if (isFetching) return <AccountInfoSkeleton />
    if (isError) return <AccountInfoError refetch={refetch} />

    return (
      <>
        {hasHeader ? (
          <Header
            title={title[language]}
            isDarkMode={isDarkMode}
            isToranja
            onClick={handleBackButton}
          />
        ) : (
          <div style={{ marginBottom: 'var(--spacing-24)' }} />
        )}

        {data?.tipoConta.map((conta) => (
          <div
            key={conta.nome}
            style={{
              padding: '0 var(--spacing-24)',
              marginTop: 'var(--spacing-16)',
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--spacing-8)',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 'var(--spacing-16)',
                paddingBottom: '8px',
                alignItems: 'center',
              }}
            >
              <Icon asset="ic_flag_united_states" size="medium" contentDescription="US flag" />
              <Text textType="body" textSize="medium" textWeight="bold">
                {conta.nome}
              </Text>
            </div>

            <Divider variant="solid" />
            <Spacing my="xxxs" />

            {conta.informacoesConta.map((info) =>
              info.avisos ? (
                <Spacing key={info.avisos.titulo} my="xs">
                  <Notice>
                    <div className="flex flex-col gap-2">
                      <Text textSize={TextSize.Medium} textType="body" textWeight="bold">
                        {info.avisos.titulo}
                      </Text>
                      <Text textSize={TextSize.Small} textType="body">
                        {info.avisos.mensagem}
                      </Text>
                    </div>
                  </Notice>
                </Spacing>
              ) : (
                <div key={info.titulo} className="flex flex-col gap-5 mb-5">
                  <Card title={info.titulo} items={info.itens} />
                  <Divider variant="solid" />
                </div>
              ),
            )}

            <Spacing my="xxxs" />
            <Divider variant="solid" />
          </div>
        ))}

        {data?.entenda && <Understand data={data.entenda} />}

        <div style={{ marginBottom: 'var(--spacing-16)' }} />
      </>
    )
  }

  return renderAccountInfo()
}
